// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
import "./../../factories/guid";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import * as ko from "knockout";
import AppTabController from "./../../services/app-tab-controller";
import Guid from "./../../factories/guid";

class ConfigurationItemObjectTab extends GenericListSearchTab {
    ConfigurationItem: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.ConfigurationItem = parent;
    }
    ControllerUrl = "ConfigurationItemObjectTab";
    SearchType(): string {
        return "ConfigurationItems";
    }
    CustomFilter() {
        return null;
    }
    CustomToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case "ConfigurationItemObjectTabAddNew":
                //Open Object set Owner
                this.AddNewConfigurationItem();
                break;
            case "ConfigurationItemObjectTabEditObject":
                //Open Object to Edit
                this.ShowConfigurationItemTab(this.Selection());
                break;
        }
    };
    AddNewConfigurationItem() {
        //OwnerId auf aktuelle Person setzen
        var objectModel = {
            ConfigurationItemId: Guid(),
            OwnerId: this.ConfigurationItem.ConfigurationItemId()
        };
        var newTab = new TabPage("ConfigurationItem");
        newTab.Url("ConfigurationItem");
        newTab["Object"] = {};
        newTab["Object"]["OwnerId"] = this.ConfigurationItem.ConfigurationItemId();
        newTab["Object"]["OwnerName"] = this.ConfigurationItem.FullName();
        newTab.IsClosable(true);
        newTab.EnableDirtyTracking(true);
        newTab.TabLoaded = function () {
        };
        AppTabController.AddTab(newTab);
    }
    ;
    ShowConfigurationItemTab(item) {
        if (item[0] != null) {
            var newTab = new TabPage();
            newTab.Url("ConfigurationItem");
            newTab.UrlData({ id: item[0].ConfigurationItemId });
            newTab.ObjectId(item[0].ConfigurationItemId);
            AppTabController.AddTab(newTab);
        }
    }
    ;
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
}
export default ConfigurationItemObjectTab;